import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    output,
    signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import {
    ButtonColor,
    SelectSize,
    TapestryButtonModule,
    TapestryNotificationService
} from '@predictiveindex/tapestry';
import { UserProfileApi } from '../../../core-services/UserProfile/user-profile-api.connnect';
import { TranslationService, TranslationsModule } from '../../../translations';
import { DirectivesModule } from '../../Directives';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
    selector: 'language-selection-menu',
    imports: [
        MatDivider,
        TapestryButtonModule,
        DirectivesModule,
        TranslationsModule,
        ReactiveFormsModule,
        LanguageSelectorComponent
    ],
    templateUrl: './language-selection-menu.component.html',
    styleUrl: './language-selection-menu.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectionMenuComponent {
    readonly #formBuilder = inject(FormBuilder);
    readonly #TR = inject(TranslationService);
    readonly #userProfile = inject(UserProfileApi);
    readonly #notification = inject(TapestryNotificationService);
    readonly #destroyRef = inject(DestroyRef);

    dismissLanguageSelection = output();

    form = this.#formBuilder.group({
        language: this.#formBuilder.control('')
    });

    saving = signal(false);

    protected readonly ButtonColor = ButtonColor;
    protected readonly SelectSize = SelectSize;

    saveChanges(): void {
        this.saving.set(true);
        this.#userProfile
            .updateUserLanguage({
                languageLocale: this.form.value.language
            })
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe((result) => {
                if (result.hasFailure) {
                    this.#notification.create({
                        message: this.#TR.key('text.error.body'),
                        type: 'error'
                    });
                } else {
                    window.location.reload();
                }

                this.dismissLanguageSelection.emit();
                this.saving.set(false);
            });
    }
}
